export const VideosConstants = {
    GET_VIDEOS_REQUEST: 'GET_VIDEOS_REQUEST',
    GET_VIDEOS_SUCCESS: 'GET_VIDEOS_SUCCESS',
    GET_VIDEOS_FAILURE: 'GET_VIDEOS_FAILURE',
}